/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
var e={getItem:e=>sessionStorage.getItem(e),setItem:(e,t)=>{sessionStorage.setItem(e,t)}};export{e as SessionStorageService};